// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1291":"CreditScoring","5467":"DisbursementProcess","7280":"PinangDashboard","8452":"OnBoardSlideShow","9274":"Home"}[chunkId] + "." + {"1291":"7a1c3bfa","5467":"5f920022","7280":"66440a25","8452":"b7f783d6","9274":"98d5d2ba"}[chunkId] + ".chunk.css";
};